import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxGoBannerComponent } from './go-banner.component';

export const ngxGoBannerModule = angular.module('ngxGoBannerModule', [])
	.directive('ngxGoBanner', downgradeComponent({ component: NgxGoBannerComponent }))
	.name;
